import { render, staticRenderFns } from "./EntityField.vue?vue&type=template&id=148b4fc6&scoped=true&"
import script from "./EntityField.vue?vue&type=script&lang=js&"
export * from "./EntityField.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./EntityField.vue?vue&type=style&index=0&id=148b4fc6&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "148b4fc6",
  "0e5f4d14"
  
)

export default component.exports